/**
 * SMS Pricing — Single source of truth for all pricing tiers.
 * Must match backend/sms_wallet.py pricing tiers exactly.
 *
 * Prices are ex GST, AUD.
 */

// Pricing tiers: the rate you pay depends on how much you top up
export const SMS_PRICING_TIERS = [
  { maxSms: 1000,     maxAmountCents: 6500,   pricePerSms: 0.065, label: 'Up to 1,000 SMS' },
  { maxSms: 10000,    maxAmountCents: 55000,  pricePerSms: 0.055, label: 'Up to 10,000 SMS' },
  { maxSms: 50000,    maxAmountCents: 225000, pricePerSms: 0.045, label: 'Up to 50,000 SMS' },
  { maxSms: Infinity, maxAmountCents: Infinity, pricePerSms: 0.038, label: '50,000+ SMS' },
];

// Pre-defined top-up bundles shown on the Wallet page
export const SMS_BUNDLE_OPTIONS = [
  { amountCents: 6500,   label: '$65',    smsEstimate: 1000,   pricePerSms: '$0.065', tag: null },
  { amountCents: 27500,  label: '$275',   smsEstimate: 5000,   pricePerSms: '$0.055', tag: null },
  { amountCents: 55000,  label: '$550',   smsEstimate: 10000,  pricePerSms: '$0.055', tag: 'Most Popular' },
  { amountCents: 225000, label: '$2,250', smsEstimate: 50000,  pricePerSms: '$0.045', tag: null },
  { amountCents: 380000, label: '$3,800', smsEstimate: 100000, pricePerSms: '$0.038', tag: null },
];

/**
 * Get the per-SMS price for a given SMS count.
 */
export function getSmsPricing(count) {
  for (const tier of SMS_PRICING_TIERS) {
    if (count <= tier.maxSms) {
      return tier.pricePerSms;
    }
  }
  return SMS_PRICING_TIERS[SMS_PRICING_TIERS.length - 1].pricePerSms;
}

/**
 * Calculate SMS estimate and rate for a custom dollar amount.
 */
export function calculateCustomAmount(dollarAmount) {
  if (dollarAmount < 25) return { smsEstimate: 0, pricePerSms: '-' };

  let pricePerSms = 0.065;
  if (dollarAmount >= 3800) pricePerSms = 0.038;
  else if (dollarAmount >= 2250) pricePerSms = 0.045;
  else if (dollarAmount >= 275) pricePerSms = 0.055;

  const smsEstimate = Math.floor(dollarAmount / pricePerSms);
  return { smsEstimate, pricePerSms: `$${pricePerSms.toFixed(3)}` };
}

/**
 * Default per-SMS cost in cents for rough estimates.
 * Uses the lowest tier (most common for small businesses).
 */
export const DEFAULT_SMS_COST_CENTS = 6.5;
